export default function GoldenCrownIcon({ size = 14, className = "", crownName = "Golden Crown" }) {
  const crownAssets = {
    "Bronze Crown": "/BronzeCrown.png",
    "Silver Crown": "/SilverCrown.png",
    "Golden Crown": "/GoldenCrown500.png",
  };
  const crownGlows = {
    "Bronze Crown": "drop-shadow(0 0 8px rgba(180, 130, 80, 0.85))",
    "Silver Crown": "drop-shadow(0 0 8px rgba(185, 205, 220, 0.85))",
    "Golden Crown": "drop-shadow(0 0 8px rgba(234, 179, 8, 0.8))",
  };
  return (
    <img
      data-testid={`crown-icon-${crownName.toLowerCase().replace(" ", "-")}`}
      src={crownAssets[crownName] || crownAssets["Golden Crown"]}
      alt={crownName}
      className={`inline-block ${className}`}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        filter: crownGlows[crownName] || crownGlows["Golden Crown"]
      }}
      title={`Current ${crownName} Holder`}
    />
  );
}
